import { render, staticRenderFns } from "./supply.vue?vue&type=template&id=592ca9a1&scoped=true"
import script from "./supply.vue?vue&type=script&lang=ts"
export * from "./supply.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592ca9a1",
  null
  
)

export default component.exports